module.exports = {
	"ha": "viha",
	"id": 5.5,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Island Health by Age Category and MSM Status, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -80,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 88.46153846153845,
						"dataLabels": {
							"enabled": false,
							"format": "23"
						},
						"color": "#043f61"
					},
					{
						"y": 69.23076923076923,
						"dataLabels": {
							"enabled": false,
							"format": "18"
						},
						"color": "#0c4250"
					},
					{
						"y": 65.38461538461539,
						"dataLabels": {
							"enabled": false,
							"format": "17"
						},
						"color": "#0d4440"
					},
					{
						"y": 53.84615384615385,
						"dataLabels": {
							"enabled": false,
							"format": "14"
						},
						"color": "#09472e"
					},
					{
						"y": 42.30769230769231,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 95,
						"dataLabels": {
							"enabled": false,
							"format": "38"
						},
						"color": "#043f61"
					},
					{
						"y": 87.5,
						"dataLabels": {
							"enabled": false,
							"format": "35"
						},
						"color": "#0c4250"
					},
					{
						"y": 85,
						"dataLabels": {
							"enabled": false,
							"format": "34"
						},
						"color": "#0d4440"
					},
					{
						"y": 82.5,
						"dataLabels": {
							"enabled": false,
							"format": "33"
						},
						"color": "#09472e"
					},
					{
						"y": 65,
						"dataLabels": {
							"enabled": false,
							"format": "26"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 94,
						"dataLabels": {
							"enabled": false,
							"format": "47"
						},
						"color": "#043f61"
					},
					{
						"y": 84,
						"dataLabels": {
							"enabled": false,
							"format": "42"
						},
						"color": "#0c4250"
					},
					{
						"y": 82,
						"dataLabels": {
							"enabled": false,
							"format": "41"
						},
						"color": "#0d4440"
					},
					{
						"y": 76,
						"dataLabels": {
							"enabled": false,
							"format": "38"
						},
						"color": "#09472e"
					},
					{
						"y": 62,
						"dataLabels": {
							"enabled": false,
							"format": "31"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.34146341463415,
						"dataLabels": {
							"enabled": false,
							"format": "237"
						},
						"color": "#043f61"
					},
					{
						"y": 93.08943089430895,
						"dataLabels": {
							"enabled": false,
							"format": "229"
						},
						"color": "#0c4250"
					},
					{
						"y": 90.65040650406505,
						"dataLabels": {
							"enabled": false,
							"format": "223"
						},
						"color": "#0d4440"
					},
					{
						"y": 85.77235772357723,
						"dataLabels": {
							"enabled": false,
							"format": "211"
						},
						"color": "#09472e"
					},
					{
						"y": 69.10569105691057,
						"dataLabels": {
							"enabled": false,
							"format": "170"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "13"
						},
						"color": "#043f61"
					},
					{
						"y": 92.3076923076923,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#0c4250"
					},
					{
						"y": 84.61538461538461,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#0d4440"
					},
					{
						"y": 61.53846153846154,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#09472e"
					},
					{
						"y": 61.53846153846154,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 90,
						"dataLabels": {
							"enabled": false,
							"format": "27"
						},
						"color": "#043f61"
					},
					{
						"y": 80,
						"dataLabels": {
							"enabled": false,
							"format": "24"
						},
						"color": "#0c4250"
					},
					{
						"y": 73.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "22"
						},
						"color": "#0d4440"
					},
					{
						"y": 53.333333333333336,
						"dataLabels": {
							"enabled": false,
							"format": "16"
						},
						"color": "#09472e"
					},
					{
						"y": 40,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.62921348314607,
						"dataLabels": {
							"enabled": false,
							"format": "86"
						},
						"color": "#043f61"
					},
					{
						"y": 91.01123595505618,
						"dataLabels": {
							"enabled": false,
							"format": "81"
						},
						"color": "#0c4250"
					},
					{
						"y": 85.39325842696628,
						"dataLabels": {
							"enabled": false,
							"format": "76"
						},
						"color": "#0d4440"
					},
					{
						"y": 71.91011235955057,
						"dataLabels": {
							"enabled": false,
							"format": "64"
						},
						"color": "#09472e"
					},
					{
						"y": 50.56179775280899,
						"dataLabels": {
							"enabled": false,
							"format": "45"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.75784753363229,
						"dataLabels": {
							"enabled": false,
							"format": "218"
						},
						"color": "#043f61"
					},
					{
						"y": 93.27354260089686,
						"dataLabels": {
							"enabled": false,
							"format": "208"
						},
						"color": "#0c4250"
					},
					{
						"y": 87.89237668161435,
						"dataLabels": {
							"enabled": false,
							"format": "196"
						},
						"color": "#0d4440"
					},
					{
						"y": 80.26905829596413,
						"dataLabels": {
							"enabled": false,
							"format": "179"
						},
						"color": "#09472e"
					},
					{
						"y": 60.0896860986547,
						"dataLabels": {
							"enabled": false,
							"format": "134"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 66.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "14"
						},
						"color": "#043f61"
					},
					{
						"y": 47.61904761904761,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#0c4250"
					},
					{
						"y": 47.61904761904761,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#0d4440"
					},
					{
						"y": 38.095238095238095,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#09472e"
					},
					{
						"y": 23.809523809523807,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 94.73684210526315,
						"dataLabels": {
							"enabled": false,
							"format": "36"
						},
						"color": "#043f61"
					},
					{
						"y": 81.57894736842105,
						"dataLabels": {
							"enabled": false,
							"format": "31"
						},
						"color": "#0c4250"
					},
					{
						"y": 76.31578947368422,
						"dataLabels": {
							"enabled": false,
							"format": "29"
						},
						"color": "#0d4440"
					},
					{
						"y": 52.63157894736842,
						"dataLabels": {
							"enabled": false,
							"format": "20"
						},
						"color": "#09472e"
					},
					{
						"y": 42.10526315789473,
						"dataLabels": {
							"enabled": false,
							"format": "16"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.51162790697676,
						"dataLabels": {
							"enabled": false,
							"format": "83"
						},
						"color": "#043f61"
					},
					{
						"y": 83.72093023255815,
						"dataLabels": {
							"enabled": false,
							"format": "72"
						},
						"color": "#0c4250"
					},
					{
						"y": 82.55813953488372,
						"dataLabels": {
							"enabled": false,
							"format": "71"
						},
						"color": "#0d4440"
					},
					{
						"y": 77.90697674418605,
						"dataLabels": {
							"enabled": false,
							"format": "67"
						},
						"color": "#09472e"
					},
					{
						"y": 53.48837209302325,
						"dataLabels": {
							"enabled": false,
							"format": "46"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 94.50980392156862,
						"dataLabels": {
							"enabled": false,
							"format": "241"
						},
						"color": "#043f61"
					},
					{
						"y": 81.96078431372548,
						"dataLabels": {
							"enabled": false,
							"format": "209"
						},
						"color": "#0c4250"
					},
					{
						"y": 80,
						"dataLabels": {
							"enabled": false,
							"format": "204"
						},
						"color": "#0d4440"
					},
					{
						"y": 77.25490196078432,
						"dataLabels": {
							"enabled": false,
							"format": "197"
						},
						"color": "#09472e"
					},
					{
						"y": 64.70588235294117,
						"dataLabels": {
							"enabled": false,
							"format": "165"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -11.538461538461542,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.739130434782606,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.555555555555558,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.647058823529417,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.42857142857143,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.8947368421052655,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.857142857142858,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.941176470588236,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.212121212121215,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -6.000000000000005,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.63829787234043,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.3809523809523836,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.317073170731703,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.42105263157895,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.658536585365857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.3755274261603407,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.6200873362445365,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.381165919282516,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.431279620853083,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.692307692307687,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.333333333333337,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.27272727272727,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -9.999999999999998,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.111111111111116,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.333333333333337,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.27272727272727,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.3707865168539297,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.813953488372093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.172839506172845,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.789473684210531,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -29.6875,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.2421524663677084,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.587155963302747,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.769230769230771,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.673469387755105,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.139664804469277,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -33.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -28.57142857142857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -37.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.263157894736848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.888888888888884,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.451612903225811,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -31.034482758620683,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.488372093023251,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.253012048192769,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.388888888888884,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.633802816901412,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -31.343283582089555,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.490196078431375,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.278008298755184,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.392344497607657,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.4313725490196068,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.24365482233503,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=26"
			},
			{
				"x": 9,
				"text": "30-39<br>n=40"
			},
			{
				"x": 15,
				"text": "40-49<br>n=50"
			},
			{
				"x": 21,
				"text": ">=50<br>n=246"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=13"
			},
			{
				"x": 34,
				"text": "30-39<br>n=30"
			},
			{
				"x": 40,
				"text": "40-49<br>n=89"
			},
			{
				"x": 46,
				"text": ">=50<br>n=223"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=21"
			},
			{
				"x": 59,
				"text": "30-39<br>n=38"
			},
			{
				"x": 65,
				"text": "40-49<br>n=86"
			},
			{
				"x": 71,
				"text": ">=50<br>n=255"
			}
		],
		"dataTable": {
			"MSM:<30": [
				26,
				23,
				18,
				17,
				14,
				11
			],
			"MSM:30-39": [
				40,
				38,
				35,
				34,
				33,
				26
			],
			"MSM:40-49": [
				50,
				47,
				42,
				41,
				38,
				31
			],
			"MSM:>=50": [
				246,
				237,
				229,
				223,
				211,
				170
			],
			"Non-MSM:<30": [
				13,
				13,
				12,
				11,
				8,
				8
			],
			"Non-MSM:30-39": [
				30,
				27,
				24,
				22,
				16,
				12
			],
			"Non-MSM:40-49": [
				89,
				86,
				81,
				76,
				64,
				45
			],
			"Non-MSM:>=50": [
				223,
				218,
				208,
				196,
				179,
				134
			],
			"Unknown:<30": [
				21,
				14,
				10,
				10,
				8,
				5
			],
			"Unknown:30-39": [
				38,
				36,
				31,
				29,
				20,
				16
			],
			"Unknown:40-49": [
				86,
				83,
				72,
				71,
				67,
				46
			],
			"Unknown:>=50": [
				255,
				241,
				209,
				204,
				197,
				165
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_viha_5_5.json
// module id = 340
// module chunks = 0